/* Light, dark, or whatever the device says.
 *
 * Stored per browser, and read before React mounts so the first paint is not
 * the wrong colour. Every read is wrapped: localStorage throws in a private
 * window and returns nothing after site data is cleared, and a theme is not
 * worth failing a page load over.
 */
export type Theme = 'light' | 'dark' | 'system'
const KEY = 'jd.theme'

export function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY)
    if (stored === 'light' || stored === 'dark' || stored === 'system') return stored
  } catch { /* private window, blocked storage: the system default is fine */ }
  return 'system'
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', theme)
  try { localStorage.setItem(KEY, theme) } catch { /* nothing depends on it sticking */ }
}

/** Call before React mounts, so the first paint is already right. */
export function bootTheme() { applyTheme(readTheme()) }
